import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

/* Toasts follow the Saffron Ledger theme: a quiet card with a colored left rule per severity
   (saffron accent for success, red for errors, amber for warnings, ink for info) instead
   of Sonner's default saturated green/red fills. */
const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:border-l-[3px] group-[.toaster]:shadow-[var(--shadow-soft)] group-[.toaster]:rounded-xl",
          title: "group-[.toast]:text-sm group-[.toast]:font-medium",
          description: "group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:border-l-accent [&_[data-icon]]:text-accent",
          error: "group-[.toaster]:border-l-destructive [&_[data-icon]]:text-destructive",
          warning: "group-[.toaster]:border-l-amber-500 [&_[data-icon]]:text-amber-600",
          info: "group-[.toaster]:border-l-primary [&_[data-icon]]:text-primary",
          loading: "group-[.toaster]:border-l-border",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
